// A crow, modelled facing +X: a glossy black body, broad swept wings and a
// stout beak. Ported 1:1 from age-of-mcp's classic crow.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#16161c",
      position: [0, 0.03, 0], scale: [1.5, 1, 0.95] },               // body
    { geometry: new THREE.IcosahedronGeometry(0.024, 0), color: "#1c1c24",
      position: [0.055, 0.045, 0] },                                 // head
    { geometry: new THREE.ConeGeometry(0.009, 0.034, 4), color: "#2a2a30",
      position: [0.09, 0.045, 0], rotation: [0, 0, -Math.PI / 2] },    // beak
    { geometry: new THREE.ConeGeometry(0.02, 0.085, 3), color: "#101016",
      position: [-0.01, 0.028, 0.05], rotation: [Math.PI / 2, 0, 0], scale: [1, 1, 0.3] },
    { geometry: new THREE.ConeGeometry(0.02, 0.085, 3), color: "#101016",
      position: [-0.01, 0.028, -0.05], rotation: [-Math.PI / 2, 0, 0], scale: [1, 1, 0.3] },
    { geometry: new THREE.ConeGeometry(0.014, 0.05, 4), color: "#101016",
      position: [-0.06, 0.03, 0], rotation: [0, 0, Math.PI / 2], scale: [1, 1, 0.4] }, // tail
  ];
}

export const crow = defineModel({
  id: "crow",
  batchId: "standard",
  name: "Crow",
  tags: ["creature","crow","low-poly","age-of-mcp","classic"],
  summary: "Low-poly crow.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: () => partsFor(),
  animations: [],
});
